export default {
  home: '/',
  careers: '/careers',
};
